import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL || "";

const routes = {
  getPadron: (id: string) => `${baseUrl}/getpadron/?id=${id}`,
  getVehicles: (tarifa: string) => `${baseUrl}/vehicles/?tarifa=${tarifa}`,
  zoho: (id?: string) => `${baseUrl}/prospect/${id ? `?id=${id}` : ""}`,
  emision: () => `${baseUrl}/quotation`,
  price: (model: number, amis: string, currency: string) =>
    `${baseUrl}/price/?model=${model}&amis=${amis}&currency=${currency}`,
  email: (id: string, currency: string, vehicle: string) =>
    `${baseUrl}/email/?id=${id}&currency=${currency}&vehicle=${vehicle}`,
};

class InsuranceService {
  getPadron = async (id: string) => {
    return await axios.get(routes.getPadron(id));
  };

  getVehicles = async (tarifa: string) => {
    return await axios.get(routes.getVehicles(tarifa));
  };

  sendClientData = async (data: any) => {
    return await axios.post(routes.zoho(), data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  udpateClientData = async (id: string, data: any) => {
    return await axios.put(routes.zoho(id), data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  getQuotation = async (data: any) => {
    return await axios.post(routes.emision(), data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  getPrice = async (model: number, amis: string, currency: "USD" | "CRC") => {
    return await axios.get(routes.price(model, amis, currency));
  };

  sendEmail = async (id: string, currency: string, vehicle: string) => {
    return await axios.post(routes.email(id, currency, vehicle), {
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
}

export default InsuranceService;
